











































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { WorkerListModule } from '@/store/modules/workerList';

@Component({
    name: 'WorkerListEmail'
})
export default class extends GiganautVueDialog {

  emailAddresses = '';
  copied = false;

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.copied = false;
      this.emailAddresses = '';
      let emails = '';
      for (let index = 0; index < WorkerListModule.workers.length; index++) {
        const worker = WorkerListModule.workers[index];
        if (worker.emailAddress !== ''){
            if (emails != '') {
              emails = emails + '; ';
            }
            emails = emails + worker.emailAddress;
        }       
      }
      this.emailAddresses = emails;
    }
  }

  async copy() {
    try {
      await navigator.clipboard.writeText(this.emailAddresses);
      this.copied = true;
    } catch (err) {
      this.copied = false;
    }
  }
}
